/*!
 *
 * site-mega-menu.js
 *
 */
const desktopCloseDelay = 300;
export default function initSiteMegaMenu(header) {
    const navItems = Array.from(header.querySelectorAll('.site-global__item.-has-menu'));
    const setMenuState = (navItem, open) => {
        var _a, _b, _c;
        const link = navItem.querySelector('[data-site-nav-link]');
        const button = navItem.querySelector('[data-site-nav-button]');
        const panelId = (_a = link === null || link === void 0 ? void 0 : link.getAttribute('aria-controls')) !== null && _a !== void 0 ? _a : button === null || button === void 0 ? void 0 : button.getAttribute('aria-controls');
        link === null || link === void 0 ? void 0 : link.setAttribute('aria-expanded', String(open));
        button === null || button === void 0 ? void 0 : button.setAttribute('aria-expanded', String(open));
        if (button) {
            const label = (_c = (_b = link === null || link === void 0 ? void 0 : link.textContent) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : '';
            button.setAttribute('aria-label', `${label}のメニューを${open ? '閉じる' : '開く'}`);
        }
        if (panelId) {
            const panel = document.getElementById(panelId);
            panel === null || panel === void 0 ? void 0 : panel.setAttribute('aria-hidden', String(!open));
            panel === null || panel === void 0 ? void 0 : panel.toggleAttribute('inert', !open);
            if (open)
                panel === null || panel === void 0 ? void 0 : panel.setAttribute('data-open', 'true');
            else
                panel === null || panel === void 0 ? void 0 : panel.removeAttribute('data-open');
        }
    };
    const closeAll = (except) => {
        navItems.forEach((navItem) => {
            if (navItem === except)
                return;
            setMenuState(navItem, false);
        });
    };
    navItems.forEach((navItem) => {
        const button = navItem.querySelector('[data-site-nav-button]');
        let closeTimer;
        const cancelClose = () => {
            if (closeTimer === undefined)
                return;
            window.clearTimeout(closeTimer);
            closeTimer = undefined;
        };
        const openMenu = () => {
            cancelClose();
            closeAll(navItem);
            setMenuState(navItem, true);
        };
        const closeMenu = () => {
            cancelClose();
            setMenuState(navItem, false);
        };
        const reserveClose = () => {
            cancelClose();
            closeTimer = window.setTimeout(() => {
                closeTimer = undefined;
                setMenuState(navItem, false);
            }, desktopCloseDelay);
        };
        button === null || button === void 0 ? void 0 : button.addEventListener('click', () => {
            const willOpen = button.getAttribute('aria-expanded') !== 'true';
            if (willOpen)
                openMenu();
            else
                closeMenu();
        });
        navItem.addEventListener('mouseenter', () => {
            if (window.matchMedia('(min-width: 992px) and (hover: hover)').matches)
                openMenu();
        });
        navItem.addEventListener('mouseleave', () => {
            if (window.matchMedia('(min-width: 992px) and (hover: hover)').matches)
                reserveClose();
        });
        navItem.addEventListener('focusin', () => {
            if (window.matchMedia('(min-width: 992px)').matches)
                openMenu();
        });
        navItem.addEventListener('focusout', (event) => {
            if (event.relatedTarget instanceof Node && navItem.contains(event.relatedTarget))
                return;
            if (window.matchMedia('(min-width: 992px)').matches)
                closeMenu();
        });
    });
    document.addEventListener('click', (event) => {
        if (event.target instanceof Node && !header.contains(event.target))
            closeAll();
    });
    return { closeAll };
}
